import apiClient from "../apiClient";


// src/api/fetchProductModels.ts
export interface FetchProductModelsDto {
	userUid: string | null;
	brandCode: string;
	typeLabelLong?: string;
	skip?: number;
	query?: string;
	type_category?: string;
	type_subcategory?: string;
	gender_label?: string;
	signal?: AbortSignal;
}

/*interface FetchProductModelsResponse {
	has_more: boolean;
	models: Array<{
		product_label: string;
		product_images: Array<string>;
		firestore_id: string;
		score: number;
	}>;
}*/

type FetchProductModelsResponse = [
	{
		has_more: boolean;
		models: Array<{
			product_label: string;
			product_images: Array<string>;
			firestore_id: string;
			score: number;
		}>;
	}
];

export const fetchProductModels = async (fetchProductModelsDto: FetchProductModelsDto) => {
	try {
		const productModels: FetchProductModelsResponse = await apiClient('/cf/fetch_product_models', {
			method: 'POST',
			signal: fetchProductModelsDto.signal,
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				user_uid: fetchProductModelsDto.userUid ?? null,
				brand_code: fetchProductModelsDto.brandCode,
				type_label_long: fetchProductModelsDto.typeLabelLong ?? '',
				type_category: fetchProductModelsDto.type_category ?? '',
				type_subcategory: fetchProductModelsDto.type_subcategory ?? '',
				skip: fetchProductModelsDto.skip ?? 0,
				query: fetchProductModelsDto.query ?? '',
				gender_label: fetchProductModelsDto.gender_label ?? '',
				allow_live_scrape: false
			}),
		});

		//const productModels = await response.json();
		console.debug('Product models fetched:', productModels);

		/*if (!Array.isArray(productModels) || !productModels[0]?.models) {
			throw new Error('Unexpected response format');
		}*/

		return {
			hasMore: productModels[0].has_more,
			models: productModels[0].models,
		};
	} catch (error) {
		console.error('Error fetching product models:', error);
		throw new Error('PRODUCT_MODELS_DATA_FETCH_FAILED');
	}
};
